import { render } from "./DocumentPreviewDialog.vue?vue&type=template&id=6dba0a8a&scoped=true"
import script from "./DocumentPreviewDialog.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewDialog.vue?vue&type=script&lang=js"

import "./DocumentPreviewDialog.vue?vue&type=style&index=0&id=6dba0a8a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dba0a8a"]])

export default __exports__